import React from 'react'
import {
  Button, Row, Col, Form, Collapse, Input, message, Select,
} from 'antd'

import { CloseOutlined, SearchOutlined } from '@ant-design/icons'

const { Panel } = Collapse
const { Option } = Select

const MasterSiteFilter = ({ onSearch }) => {
  const [form] = Form.useForm()

  const onClickSearch = () => {
    form.validateFields()
      .then((values) => {
        onSearch(values)
      })
      .catch((info) => {
        message.error('Master site validate failed!')
        console.log('Master site validate failed:', info)
      })
  }

  const onClickClearFilter = () => {
    form.resetFields()
    onSearch(null)
  }

  return (
    <>
      <Collapse
        bordered={false}
        defaultActiveKey={['0']}
      >
        <Panel
          header="Filter"
          key="1"
          style={{
            background: '#f7f7f7',
            borderRadius: 4,
            border: 0,
            overflow: 'hidden',
          }}
          extra={(
            <Button
              type="link"
              size="small"
              onClick={() => {
                onClickClearFilter()
              }}
            >
              <CloseOutlined />
              Clear Filter
            </Button>
          )}
        >
          <Form
            form={form}
            name="master_site_filter"
            layout="vertical"
          >
            <Row gutter={24}>
              <Col xs={24} md={8}>
                <Form.Item
                  label="Site Code"
                  name="siteCode"
                >
                  <Input
                    allowClear
                    placeholder="Site Code"
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item
                  label="Site Description"
                  name="siteDescr"
                >
                  <Input
                    allowClear
                    placeholder="Site Description"
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item
                  label="Active"
                  name="isActive"
                >
                  <Select
                    allowClear
                    placeholder="Select Status"
                    defaultValue={null}
                  >
                    <Option value={null}>All</Option>
                    <Option value={1}>True</Option>
                    <Option value={0}>False</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <Row>
            <Button
              type="primary"
              style={{ width: '100%' }}
              onClick={() => {
                onClickSearch()
              }}
            >
              <SearchOutlined />
              Search
            </Button>
          </Row>
        </Panel>
      </Collapse>
    </>
  )
}

export default MasterSiteFilter
